import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { MainTitle, Spinner } from '../../../../common/index.jsx';
import { useGetWorkshopQuery } from '../../../../../redux/services/fo_workshops.jsx';
import { useGetDatesQuery } from '../../../../../redux/services/fo_dates.jsx';
import WorkshopsDetail from '../../../../common/FriOpen/Workshops/WorkshopsDetail.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { useSelector } from 'react-redux';
import useUserHasRole from '../../../../../hooks/useUserHasRoles.jsx';
import { ROLE_FRI_OPEN_PARTICIPANT } from '../../../../../utils/constants/roles.js';

const WorkshopsDetailPublicPage = () => {
  const { t } = useTranslation();
  const { workshopId } = useParams();
  const user = useSelector((state) => state.auth.user);
  const isFriOpenParticipant = useUserHasRole(ROLE_FRI_OPEN_PARTICIPANT);
  const navigate = useNavigate();

  const { data: workshop, isLoading: isLoadingWorkshop } =
    useGetWorkshopQuery(workshopId);
  const { data: dates, isLoading: isLoadingDates } =
    useGetDatesQuery(workshopId);

  return (
    <>
      <MainTitle title={t('FRI akcia - detail seminára')} backAction={true} />

      {user && isFriOpenParticipant && (
        <FormButtonsContainer>
          <FormButton
            onClick={() => {
              navigate(routes.cmsFoWorkshopsDetail(workshop.id));
            }}
          >
            {t('Prejsť do portálu FRI a vybrať si termín')}
          </FormButton>
        </FormButtonsContainer>
      )}

      {!user && (
        <FormButtonsContainer>
          <FormButton
            onClick={() => {
              navigate(`${routes.externalUserRegistration}?from=fri-open`);
            }}
          >
            {t('Registrovať sa do portálu FRI (nemám konto)')}
          </FormButton>
          <FormButton
            onClick={() => {
              navigate(routes.cmsFoWorkshopsDetail(workshop.id));
            }}
          >
            {t('Prihlásiť sa do portálu FRI a vybrať si termín (mám konto)')}
          </FormButton>
        </FormButtonsContainer>
      )}

      {isLoadingWorkshop || isLoadingDates ? (
        <Spinner />
      ) : (
        <WorkshopsDetail
          workshop={workshop}
          dates={dates}
          onDetailClick={(date) => navigate(routes.friOpenDatesDetail(date.id))}
          onRowClick={(date) => navigate(routes.friOpenDatesDetail(date.id))}
        />
      )}
    </>
  );
};

export default WorkshopsDetailPublicPage;
